<template>
  <div class="page">
    <Header
      :setting="{
        title: '院所資訊',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div
      @click="$router.push({path: '/introduction/doctor'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          醫療團隊
        </div>
      </div>
    </div>
    <div
      @click="$router.push({path: '/introduction/about-us'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          關於我們
        </div>
      </div>
    </div>
    <div
      @click="$router.push({path: '/introduction/find-us'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          交通資訊
        </div>
      </div>
    </div>
  </div>
</template>
